export default "__VITE_PUBLIC_ASSET__20371a34__"